import searchStatus from "../helpers/searchStatusEnum";

const baseUrlFunc = "https://jupiterfunctions.azurewebsites.net/api";

export default {
  authorizeUrl: `${baseUrlFunc}/Authorize`,
  createManufacturerUrl: `${baseUrlFunc}/CreateManufacturer`,
  deleteManufacturerUrl: `${baseUrlFunc}/DeleteManufacturer`,
  products: [],
  productsTotal: 0,
  productsPerPage: 20,
  categories: [], // categories contains rafined cdata only to be used for list representation
  cdata: [], // cdata contains raw categories data including all images, contact information etc...
  manufacturers: [], // manufacturers contains rafined mdata only to be used for list representation
  allManufacturers: [],
  allNormalizedManufacturers: [],
  mdata: [], // mdata contains raw manufacturers data including all images, contact information etc...
  filteredManufacturerIds: [],
  suppliers: [], // suppliers contains rafined mdata only to be used for list representation
  allSuppliers: [],
  allNormalizedSuppliers: [],
  sdata: [], // sdata contains raw suppliers data including all images, contact information etc...
  filteredSupplierIds: [],

  selectedCategoryId: null,

  currentSearchStatus: searchStatus.INITIAL,
  isPromo: false,

  rawString: "",
  searchString: "",
  results: [],
  facets: [],
  filters: [],
  filterString: "",
  currentPage: 1,
  resultsPerPage: 20,
  orderBy: [""],
  getImagesUrl:
    "https://jupiterfunctions.azurewebsites.net/api/GetItemImagesByIds",
  getManufacturerImagesUrl:
    "https://jupiterfunctions.azurewebsites.net/api/GetManufacturerImagesByIds",
  itemIds: [],
  itemManufacturerIds: [],
  priceSortingOptions: [
    {
      id: 1,
      label: "sortirano po cijeni opadajuće",
    },
    {
      id: 2,
      label: "sortirano po cijeni rastuće",
    },
  ],
  priceSortingSelected: 0,
  priceSortingIndex: 0,
};
